import Component from './components';
import OverlayComponent from './components/overlay';

export default Component;
export const Overlay = OverlayComponent;
